export default "__VITE_ASSET__65e1e269__"